import { SaveAlt, Search } from "@material-ui/icons";
import { Fab, Grid, TextField, Tooltip } from "@mui/material";
import Select from "components/select/Select";
import {
  ALL_OPTION,
  BUSINESS_PHONE_NUMBER_TYPES,
  BUSINESS_TELECOM_OPERATORS,
} from "constant";
import { useListPbxTypeAndBusiness } from "hooks/business-management/useListPbxTypeAndBusiness";
import { getSelectFieldProps, getTextFieldProps } from "ultis/form";

const BusinessPhoneNumberFilter = ({ formik, onClickDownload }) => {
  const { listBusiness, listPbxType } = useListPbxTypeAndBusiness(
    formik.values.pbxType
  );

  return (
    <form onSubmit={formik.handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={3}>
          <Select
            {...getSelectFieldProps(formik, "pbxType")}
            onChange={(newValue) => {
              formik.setFieldValue("pbxType", newValue);
              formik.setFieldValue("businessCode", ALL_OPTION.value);
            }}
            label="Loại tổng đài"
            options={listPbxType?.map((item) => ({
              label: item.name,
              value: item.pbxType,
            }))}
            showAllOption
          />
        </Grid>
        <Grid item xs={3}>
          <Select
            {...getSelectFieldProps(formik, "businessCode")}
            label="Nghiệp vụ"
            options={listBusiness?.map((item) => ({
              label: item.name,
              value: item.businessCode,
            }))}
            showAllOption
          />
        </Grid>
        <Grid item xs={3}>
          <Select
            {...getSelectFieldProps(formik, "typeDial")}
            options={BUSINESS_PHONE_NUMBER_TYPES}
            label="Loại đầu số"
            showAllOption
          />
        </Grid>
        <Grid item xs={3}>
          <Select
            {...getSelectFieldProps(formik, "telecomOperator")}
            options={BUSINESS_TELECOM_OPERATORS}
            label="Nhà mạng"
            showAllOption
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            {...getTextFieldProps(formik, "phoneNumber")}
            label="Đầu số"
          />
        </Grid>

        <Grid item xs={3}>
          <Tooltip title="Tìm kiếm" disableFocusListener>
            <Fab
              color="primary"
              aria-label="Search"
              type="submit"
              sx={{ mr: 1 }}>
              <Search />
            </Fab>
          </Tooltip>
          <Tooltip title="Tải xuống tất cả đầu số nghiệp vụ">
            <Fab color="primary" aria-label="export" onClick={onClickDownload}>
              <SaveAlt />
            </Fab>
          </Tooltip>
        </Grid>
      </Grid>
    </form>
  );
};

export default BusinessPhoneNumberFilter;
